import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { FieldsetModule } from 'primeng/fieldset';
import { InputMaskModule } from 'primeng/inputmask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FileUploadModule } from 'primeng/fileupload';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { MenubarModule } from 'primeng/menubar';
import { CardModule } from 'primeng/card';
import { EditorModule } from 'primeng/editor';
import { BlockUIModule } from 'primeng/blockui';
import { ImageModule } from 'primeng/image';
import { CalendarModule } from 'primeng/calendar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { CheckboxModule } from 'primeng/checkbox';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { BadgeModule } from 'primeng/badge';
import { ChipModule } from 'primeng/chip';
import { SplitterModule } from 'primeng/splitter';
import { DataViewModule } from 'primeng/dataview';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { SplitButtonModule } from 'primeng/splitbutton';
import { StepperModule } from 'primeng/stepper';
import { SidebarModule } from 'primeng/sidebar';
import { TagModule } from 'primeng/tag';
import { TreeSelectModule } from 'primeng/treeselect';
import { TreeTableModule } from 'primeng/treetable';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { RefreshTableButtonComponent } from './refresh-table-button/refresh-table-button.component';
import { BackButtonComponent } from './components/back-button/back-button.component';
import { BreadcrumbWithBackComponent } from './components/breadcrumb-with-back/breadcrumb-with-back.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { ResponsiveTableDirective } from './directives/responsive-table.directive';
import { ColombiaDatePipe } from '../../pipes/colombia-date.pipe';
import { DividerModule } from 'primeng/divider';
import { MessageModule } from 'primeng/message';
import { SkeletonModule } from 'primeng/skeleton';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccordionModule } from 'primeng/accordion';
import { ProgressBarModule } from 'primeng/progressbar';

const primeModules = [
  TableModule,
  ButtonModule,
  DialogModule,
  ToolbarModule,
  PanelModule,
  InputTextModule,
  DropdownModule,
  FieldsetModule,
  InputMaskModule,
  AutoCompleteModule,
  ToastModule,
  ConfirmDialogModule,
  FloatLabelModule,
  FileUploadModule,
  IconFieldModule,
  InputIconModule,
  InputGroupModule,
  InputGroupAddonModule,
  InputNumberModule,
  MultiSelectModule,
  ConfirmPopupModule,
  MenubarModule,
  CardModule,
  EditorModule,
  BlockUIModule,
  ImageModule,
  CalendarModule,
  InputSwitchModule,
  CheckboxModule,
  TriStateCheckboxModule,
  RadioButtonModule,
  InputTextareaModule,
  OverlayPanelModule,
  MenuModule,
  AvatarModule,
  AvatarGroupModule,
  BadgeModule,
  ChipModule,
  SplitterModule,
  DataViewModule,
  TieredMenuModule,
  SplitButtonModule,
  StepperModule,
  SidebarModule,
  TagModule,
  TreeSelectModule,
  TreeTableModule,
  TabViewModule,
  TooltipModule,
  DividerModule,
  MessageModule,
  ProgressSpinnerModule,
  AccordionModule,
  ProgressBarModule,
  SkeletonModule
]

@NgModule({
  declarations: [
    LocalDatePipe,
    ColombiaDatePipe,
    BackButtonComponent,
    BreadcrumbWithBackComponent,
    ResponsiveTableDirective
  ],
  imports: [
    CommonModule,
    RouterModule,
    ...primeModules,
    //QRCodeComponent,
    RefreshTableButtonComponent
  ],
  exports: [
    CommonModule,
    RouterModule,
    ...primeModules,
    RefreshTableButtonComponent,
    BackButtonComponent,
    LocalDatePipe,
    ColombiaDatePipe,
    BreadcrumbWithBackComponent,
    ResponsiveTableDirective
  ]
})
export class SharedModule { }

